import React from 'react'
import PropTypes from 'prop-types'

import RadioGroupProvider from 'providers/RadioGroupProvider'

const TableRadioGroup = ({ name, value, onChange, onChangeData, children }) => {
  return (
    <RadioGroupProvider
      name={name}
      value={value}
      onChange={onChange}
      onChangeData={onChangeData}
    >
      {children}
    </RadioGroupProvider>
  )
}

TableRadioGroup.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node),
  name: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  onChangeData: PropTypes.func,
}

export default TableRadioGroup
